export default __webpack_public_path__ + "static/media/stimmex-festival-2026_sx mobile.347751f9.png";